import React from "react";
import "./customTable.css";
import commoncss from "../../../myfin_v2/css/common.module.css"


// const MERGE_KEYS = ["date", "particular"];
const MERGE_KEYS = ["date"];

const flatten = (nodes, rows = []) => {
  if (!Array.isArray(nodes)) return rows;

  nodes.forEach((n) => {
    if ((n.level || 0) <= 2) {
      rows.push({
        _id: n._id,
        date: n.date || null,
        particular: n.name || "",
        // references: Array.isArray(n.references) ? n.references.join(", ") : "",
        notes: n.notes || "",
        lineType: n.lineType,
        level: n.level || 0,
        companies: n.companies || [],
      });
    }

    if (Array.isArray(n.subgroup)) {
      flatten(n.subgroup, rows);
    }
  });

  return rows;
};

const buildRowSpans = (rows) => {
  const map = {};
  const used = {};

  rows.forEach((r) => {
    const key = MERGE_KEYS.filter((k) => r[k]) // ignores missing date
      .map((k) => r[k])
      .join("||");

    map[key] = (map[key] || 0) + 1;
  });

  return rows.map((r) => {
    const key = MERGE_KEYS.filter((k) => r[k])
      .map((k) => r[k])
      .join("||");

    if (used[key]) {
      return { ...r, _hideMerge: true };
    }

    used[key] = true;
    return { ...r, _rowSpan: map[key] };
  });
};

const BSPLTable = ({ tableData, redirectTo = () => {} }) => {
  const flat = flatten(tableData || []);
  const rows = buildRowSpans(flat);

  const sample = rows.find((r) => r.companies.length);
  if (!sample) return null;

  const companies = sample.companies.map((c) => c.title);

  const periods = Object.keys(sample.companies[0]).filter(
    (k) => k !== "title" && !k.startsWith("_")
  );

  const baseColumns = Array.from(
    new Set(
      rows.flatMap((r) =>
        Object.keys(r).filter((k) => {
          if (k.startsWith("_")) return false;
          if (k === "companies" || k === "level" || k === "lineType")
            return false;

          // DATE: show only if at least one row has a value
          if (k === "date") {
            return rows.some((x) => x.date);
          }

          // All other fields (references, notes, etc.) should appear if key exists
          return true;
        })
      )
    )
  );

  const totalCols = baseColumns.length + companies.length * periods.length;

  return (
    <div className="table-container">
      <table className="financial-table">
        <thead>
          <tr>
            {baseColumns.map((c) => (
              <th key={c} rowSpan={2} className={c === "notes" ? "notes-col tableHeadingColor " : "col-text tableHeadingColor"}>
              {c.toUpperCase()}
              </th>
            ))}

            {companies.map((c) => (
              <th key={c} colSpan={periods.length} className="col-group tableHeadingColor">
                {c}
              </th>
            ))}
          </tr>

          <tr>
            {companies.map(() =>
              periods.map((p) => (
                <th key={p} className="year-heading tableHeadingColor">
                  {p === "currentYear" ? "CY" : "PY"}
                </th>
              ))
            )}
          </tr>
        </thead>

        <tbody>
          
          {rows.map((row, idx) => {
            /* Level 1 = Section Header */
            if (row.level === 1) {
              return (
                // <tr key={idx} className="section-row">
                //   <td
                //     colSpan={totalCols}
                //     className="section-cell"
                //   >
                //     {row.particular}
                //   </td>
                //   <td></td>
                // </tr>
                <tr key={idx} className="row-header">
                <td className="col-text header-cell">
                  {row.particular}
                </td>

                <td className="notes-col header-cell"></td>
                <td className="header-cell" colSpan={totalCols - 2}></td>
              </tr>

              );
            }

            return (
              <tr key={idx}>
                {baseColumns.map((col) => {
                  if (MERGE_KEYS.includes(col)) {
                    if (row._hideMerge) return null;

                    return (
                      <td key={col} rowSpan={row._rowSpan} className="col-text">
                        {row[col]}
                      </td>
                    );
                  }

                  return (
                    <td key={col} className={col === "notes" ? "notes-col" : "col-text"}>
                      <span className={`${col === "notes" && commoncss.clickable}`} onClick={() => col === "notes" && redirectTo(row[col])}>
                      {row[col]}
                      </span>
                    </td>
                  );
                })}

                {row.companies.map((c) =>
                  periods.map((p) => (
                    <td key={`${c.title}-${p}`} className="col-number">
                      {c[p]}
                    </td>
                  //   <td key={`${c.title}-${p}`} className="col-number">
                  //   {c[p] !== null && c[p] !== undefined
                  //     ? Number(c[p]).toLocaleString("en-IN")
                  //     : ""}
                  // </td>
                  ))
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default BSPLTable;
